module.exports = __webpack_public_path__ + "img/cloth_g3_item-02.a242c3ab.svg";